import styled from 'styled-components';

export const SelectionCard = styled.div<{ isSelected?: boolean; isDisabled?: boolean }>(
  ({ theme, isSelected, isDisabled }) => `
  background-color: ${
    isDisabled
      ? theme.colors.surface.background.gray.moderate
      : isSelected
        ? theme.colors.interactive.background.primary.faded
        : theme.colors.surface.background.gray.subtle
  };
  border: 1px solid ${
    isDisabled
      ? theme.colors.surface.border.gray.muted
      : isSelected
        ? theme.colors.interactive.border.primary.default
        : theme.colors.surface.border.gray.normal
  };
  border-radius: ${theme.border.radius.medium}px;
  padding: ${theme.spacing[4]}px;
  cursor: ${isDisabled ? 'not-allowed' : 'pointer'};
  opacity: ${isDisabled ? '0.7' : '1'};
  transition: all 0.2s ease;
  
  ${!isDisabled ? `
    &:hover {
      border-color: ${theme.colors.interactive.border.primary.default};
      background-color: ${theme.colors.interactive.background.gray.faded};
    }
  ` : ''}
`
);
